<template>
    <section class="publication-single">
        <article class="publication" id="eah">
            <header class="publication--header">
                <div id="trigger1" class="spacer s0" style="position:absolute; top: 50vh"></div>
                <h1 class="publication--title" v-bind:class="{ 'xs': isLongTitle(publication.title) }" ref="animTitleUp" style="max-width: 890px">{{ publication.title }}</h1>
                <div class="publication--cover" ref="animCoverUp">
                    <img
                    :src="require(`@/assets/images/articles/${publication.cover}`)"
                    alt="">
                </div>
                <ul class="publication--categories">
                    <li class="publication--categories-item">Correspondance</li>
                    <li class="publication--categories-item">Crime et Mystère</li>
                </ul>
            </header>
            <div class="publication--content" ref="animLaxFadeContent" data-lax-opacity="0 0, 400 1" data-lax-blur="0 4, 500 0">
                <div class="publication--content-wrap" v-html="publication.content"></div>
                <div class="publication--credits">
                    <ul class="publication--credits-list">
                        <li><span>Auteur</span> Paracelsia Le Saigné</li>
                        <li><span>Crédits Photo</span> Féebrile aka Isabelle Royet-Journoud</li>
                        <li><span>Date</span> 16 juin 2020</li>
                    </ul>
                </div>
            </div>
            <div class="publication--background" ref="animLaxFade">
                <img
                    :src="require(`@/assets/images/articles/${publication.background}`)"
                    alt="">
            </div>
        </article>
        
        <router-link :to="{ name: 'Publication', params: {slug: nextPublication.slug} }" v-if="nextPublication">
            <div class="publication--next" v-observe-visibility="{ callback: visibilityChanged, throttle: 300 }">
                <h3 class="publication--next-title" v-bind:class="{ 'xs': isLongTitle(publication.title) }">{{ nextPublication.title }}</h3>
                <div class="publication--next-cover" v-if="nextPublication.thumb">
                    <img
                        :src="require(`@/assets/images/articles/${nextPublication.cover}`)"
                        alt="">
                </div>
                <span class="publication--next-label">Nouvelle suivante</span>
            </div>
        </router-link>
    </section>
</template>
<script>
import publicationsJSON from '@/content.js';

import * as ScrollMagic from "scrollmagic"; // Or use scrollmagic-with-ssr to avoid server rendering problems
import { ScrollMagicPluginIndicator} from "scrollmagic-plugins";
import { TweenMax, TimelineMax, TimelineLite, Back, Elastic, Expo } from "gsap"; // Also works with TweenLite and TimelineLite
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";

ScrollMagicPluginIndicator(ScrollMagic);
ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax, TimelineLite, Back, Elastic, Expo);

export default {
    name: "Publication",
    data() {
        return {
            show: true,
            cssProps: {
                //backgroundImage: this.$route.params.background,
            },
            nextPublication: {}
        }
    },
    props: {
        slug: {
            type: String,
            required: true
        }
    },
    computed: {
        publication(){
            return publicationsJSON.articles.find(
                publication => publication.slug === this.slug
            )
        },
        getIndex(){
            return publicationsJSON.articles.findIndex(
                getIndex => getIndex.slug === this.slug
            );
            /*var index = -1;
            var val = this.slug;
            publicationsJSON.articles.find(function(item, i){
                if(item.slug === val){
                    index = i;
                    return i;
                }
            })*/
        }
    },
    methods: {
        isLongTitle($title){
            if($title.length > 7){
                return true
            }
        },
        setParagraphs($content){
            var $reg = /<p/gi;
            $content = $content.replace($reg, '<p ref="animLaxP" data-lax-opacity="0 0, elh 0.5"');
            return $content
        },
        getNextPublication($id = this.getIndex){
            var getNextPublication = publicationsJSON.articles[$id+1];
            return getNextPublication;
        },
        visibilityChanged (isVisible, entry) {
            this.isVisible = isVisible;
            var element = entry.target;
            if( isVisible ){
                element.classList.add('visible')
            } else {
                element.classList.remove('visible')
            }
        }
    },
    mounted() {
        //document.getElementById('app').scrollIntoView();
        //console.log(this);

        /*const { animCoverUp } = this.$refs;
        const timeline = new TimelineMax();
        const controller = new ScrollMagic.Controller();
        
        var tween = timeline
                    //.from(animCoverUp, 1, { opacity: 0 })
                    //.to(animCoverUp, 1, { opacity: 1 });
                    .fromTo(animCoverUp, 1, {opacity: 0}, {opacity: 1})

        // build scene
        var scene = new ScrollMagic.Scene({triggerElement: "#eah", duration: 400})
                        .setTween(tween)
                        .setPin("#eah")
                        //.debug.addIndicators({name: "2 (duration: 300)"}) // add indicators (requires plugin)
                        .addTo(controller);

        console.log(scene);*/

        const controller = new ScrollMagic.Controller();
        const { animCoverUp, animTitleUp, animLaxFade } = this.$refs
        const timelineLanding = new TimelineLite();
        const timeline = new TimelineLite();
        //const timelineBackground = new TimelineLite();
        //const timelineNextPublication = new TimelineLite();
        
        var tweenTitle = timeline
                    .fromTo(
                        animTitleUp,
                        1,
                        { opacity: 1, filter: 'blur(0)', y: 0 },
                        { opacity: 0, filter: 'blur(4px)', y: -200 },
                        "first"
                    )
                    .fromTo(
                        animCoverUp,
                        1,
                        { opacity: 1, y: 0 },
                        { opacity: 0, y: -400 },
                        "first"
                    )
                    .fromTo(animLaxFade, 1, 
                        {opacity: 1},
                        {opacity: 0},
                        "first"
                    );

        //var tween2 = timeline

            timelineLanding.fromTo(animTitleUp, 1, {
                        opacity: 0,
                        filter: 'blur(4px)',
                        y: -200,
                        
                    //ease: Back.easeOut.config(1.7),
                    },
                    {
                        opacity: 1,
                        filter: 'blur(0px)',
                        y: 0,
                        //ease: Back.easeOut.config(1.7),
                    });

        var sceneTitle = new ScrollMagic.Scene({triggerElement: "#trigger1", duration: '100%'})
                        .setTween(tweenTitle)
                        .addIndicators({name: "2 (duration: 400)"}) // add indicators (requires plugin)
                        .addTo(controller);



        //console.log(sceneTitle);

        this.sceneTitle = sceneTitle;


        this.nextPublication = this.getNextPublication();
        //console.log(this.nextPublication);

        /*var tween = timeline.to(animCoverUp, 1, { y: 200, rotation: 90 });

        const scene2 = this.$scrollmagic.scene({
            // ID of element where animation starts
            triggerElement: '#trigger1',
        
            // {0,0.5,1} - animations starts from {top,center,end} of window
            triggerHook: 0.5,
        
            // Duration of animation
            duration: 300
        })
            // Declaration of animation and attaching to element
            .setTween(tween)
            // Helpful tags for orientation on the screen
            .addIndicators({ name: '2 (duration: 300)' })

        console.log(scene2);

        this.nextPublication = this.getNextPublication();
        console.log(this.nextPublication);*/

        /*this.$route.querySelectorAll('.article--content p').forEach(element){
            var $reg = /<p/gi;
            element = element.replace($reg, '<p ref="animLaxP" data-lax-opacity="0 0, elh 0.5"');
        }*/
        
        //this.$lax.addElement(this.$refs.animTitleUp);
        //this.$lax.addElement(this.$refs.animCoverUp);
        //this.$lax.addElement(this.$refs.animLaxFade);
        //this.$lax.addElement(this.$refs.animLaxFadeContent);
        
        //this.$lax.addElement(this.$refs.animLaxP);
        // Set Title Size
        /*var $title = document.querySelector('.article--title'),
            $titleStr = $title.innerHTML; // or this.publication.title
        if($titleStr.length > 7){
            alert('true')
            $title.classList.add('xs');
        }
        console.log($title, $titleStr);*/

        /*timelineLanding.fromTo(animTitleUp, 1, {
                opacity: 0,
                filter: 'blur(4px)',
                y: -200,
                
            //ease: Back.easeOut.config(1.7),
            },
            {
                opacity: 1,
                filter: 'blur(0px)',
                y: 0,
                //ease: Back.easeOut.config(1.7),
            });*/
        
    },
    updated(){

    },
    ready(){
        this.sceneTitle.refresh();
    },
    beforeDestroy() {
        this.sceneTitle.destroy();
        //this.$lax.addElement(this.$refs.animTitleUp);
        //this.$lax.addElement(this.$refs.animCoverUp);
        //this.$lax.addElement(this.$refs.animLaxFade);
        //this.$lax.addElement(this.$refs.animLaxFadeContent);
    }
  }
</script>
<style lang="scss" scoped>
    @import "@/assets/styles/sass/templates/_publication.scss";

    /*.fadeBackground-enter-active{
        transition: animBackground 1s;
    }
    .fadeBackground-leave-active{
        transition: animBackground 1s reverse;
    }

    @keyframes animBackground {
    0% {
        opacity: 0;
        transform: scale(1.2);
    }
    50% {
        opacity: 0.4;
        transform: scale(1.2);
    }
    100% {
        opacity: 1;
        transform: scale(1);
    }
    }*/
    
.fade-enter-active,
.fade-leave-active{
  transition: opacity 1s;
}

/*.coucou-enter-to,
.coucou-leave{
  opacity: 1;
}*/

.fade-leave,
.fade-enter-to{
  opacity: 1;
}

.fade-enter,
.fade-leave-to{
  opacity: 0;
}
</style>